import { render, staticRenderFns } from "./Buttonmenu.vue?vue&type=template&id=597eba46&scoped=true&"
import script from "./Buttonmenu.vue?vue&type=script&lang=ts&"
export * from "./Buttonmenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597eba46",
  null
  
)

export default component.exports